import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { getMixiHumanCapitalDbPageConfig } from './human-capital-db-page-configs';

const dashboardId = 'human-capital';

export const MixiHumanCapitalDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Human Capital DB',
    [Languages.JA]: '全体サマリ',
  },
  enabled: true,
  pages: [
    getMixiHumanCapitalDbPageConfig({
      pageId: 1,
      dashboardId,
      title: {
        [Languages.EN]: 'Summary',
        [Languages.JA]: '全体サマリ',
      },
    }),
  ],
};
